export default "__VITE_ASSET__B2mYf8Xx__"